import { render, staticRenderFns } from "./FilterableFormatsSelector.vue?vue&type=template&id=6f8eda30&scoped=true&"
import script from "./FilterableFormatsSelector.vue?vue&type=script&lang=ts&"
export * from "./FilterableFormatsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FilterableFormatsSelector.vue?vue&type=style&index=0&id=6f8eda30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8eda30",
  null
  
)

export default component.exports